module.exports = __webpack_public_path__ + "static/img/logo3@2x.342e711.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/logo3@2x.png
// module id = YCBB
// module chunks = 70